import http from '../../services/httpService';
import apiEndpoint from '../../constants/config.json'

//create method create_new_check_out_order

export function fetchAllWeddingRegistryItems(){
    const fullApiEndpoint = apiEndpoint.apiEndpoint + "/weddingRegistryManagement/api/fetch_all_registry_products";
    return http.get(fullApiEndpoint);
}